/**
 * PreferencesPanel - User preferences settings
 * Handles: Fuel costs, display settings (stored locally)
 */
import React from 'react';

const PreferencesPanel = () => (
  <div className="space-y-4">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <span className="text-sm font-medium text-stone-500">Default Vehicle MPG</span>
        <p className="text-stone-900">25 MPG</p>
      </div>
      <div>
        <span className="text-sm font-medium text-stone-500">Default Gas Price</span>
        <p className="text-stone-900">$3.50/gallon</p>
      </div>
    </div>
    <p className="text-xs text-stone-400 italic">Preferences are currently stored locally in your browser.</p>
  </div>
);

export default PreferencesPanel;
